/**
 * Bounded context: Onboarding
 *
 * State machine dos 5 turnos do onboarding (D7 / ADR-0014).
 *
 * Constitucional:
 * - Princípio V (Aprendiz Decide): toda transição é iniciada pelo usuário
 *   (clique). Nada avança sozinho.
 * - CC-01..08: zero timer visível, zero streak, zero nudge.
 * - LGPD: Turn 4 pede "algo que eu deveria saber sobre você" — usuário
 *   pode responder livremente ou pular (skip).
 * - ADR-0014 (D7): onboarding ≤5min total (validação interna, não exibida).
 */

/** Turno atual do onboarding. */
export type OnboardingStep =
  | "intro" // Turn 1: apresentação do Companheiro.
  | "name" // Turn 2: como você quer ser chamado?
  | "focus" // Turn 3: o que quer compreender melhor?
  | "personal" // Turn 4: algo que eu deveria saber sobre você?
  | "mnemonic"; // Turn 5: 24 palavras (placeholder em v0.2; HLOS-7 ativa vault).

/** Resposta opcional do usuário em cada turno. */
export interface OnboardingDraft {
  /** Como o usuário quer ser chamado (Turn 2). */
  readonly name: string | null;
  /** Foco de compreensão (Turn 3). */
  readonly focus: string | null;
  /** Contexto pessoal opcional (Turn 4; pode ser string vazia se pulou). */
  readonly personal: string | null;
  /** Se o usuário confirmou ter anotado as 24 palavras (Turn 5). */
  readonly mnemonicConfirmed: boolean;
}

/** Estado inicial — nenhum campo preenchido. */
export const INITIAL_DRAFT: OnboardingDraft = Object.freeze({
  name: null,
  focus: null,
  personal: null,
  mnemonicConfirmed: false,
});

/**
 * Ordem canônica dos 5 turnos. Exportada para auditoria CC / Constitutional
 * Guardian — qualquer reordenação é violação direta de D7/ADR-0014.
 */
export const ONBOARDING_STEPS: readonly OnboardingStep[] = Object.freeze([
  "intro",
  "name",
  "focus",
  "personal",
  "mnemonic",
]);
